import { PublicKey } from "@solana/web3.js";
import { Cluster } from "@solana/web3.js";

export const PROGRAM_ID = new PublicKey("ListaMe2rbrc8w5X2gnzQvZzPBGLNCB6VuVAKCgRHU4");
export const CURRENT_DATA_VERSION = 0;

export const getProtocolTreasury = (cluster: Cluster): PublicKey => {
	switch (cluster) {
		default: {
			return new PublicKey("EQ66GiBpGyDdZmwMsP69YbG2EKfAXVNivPCKboMgxwJ4");
		};
	}
};

export const getPythSolUsdFeed = (): PublicKey => {
	return new PublicKey("J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix");
};